import { AsYouType, isValidNumber, parsePhoneNumberFromString, } from "libphonenumber-js";
import { isValidPhoneNumber } from "libphonenumber-js/max";
import { isValidEmail } from "../email.utils";
export var cleanPhone = function (phone) {
    if (!phone) {
        return;
    }
    var result = phone;
    result.replace(" ", "");
    if (result && result.length > 0) {
        // Replace '00' at start with '+'
        if (result.startsWith("00")) {
            result = "+" + result.substring(2);
        }
        // Replace '04' at start with '+324'
        if (result.startsWith("04")) {
            result = "+32 4" + result.substring(2);
        }
        // Replace '+3204' at start with '+324'
        if (result.startsWith("+3204")) {
            result = "+32 4" + result.substring(5);
        }
        // Replace '+3200' at start with '+32'
        if (result.startsWith("+3200")) {
            result = "+32" + result.substring(5);
        }
    }
    return result;
};
export var formatPhoneWhileTyping = function (phone) {
    var cleaned = cleanPhone(phone);
    var parsed = parsePhoneNumberFromString(cleaned || "");
    if (!parsed) {
        parsed = cleaned;
    }
    if (!cleaned) {
        return;
    }
    return new AsYouType().input(cleaned);
};
export var formatPhoneWhileTypingWithoutSpaces = function (phone) {
    var parsed = formatPhoneWhileTyping(phone);
    if (!parsed) {
        return;
    }
    return parsed.replace(/ /g, "");
};
export var formatPhone = function (phone) {
    var cleaned = cleanPhone(phone);
    var parsed = parsePhoneNumberFromString(cleaned || "");
    if (!parsed) {
        return;
    }
    return parsed.formatInternational();
};
// A phone being saved must be a real number, so this checks it against the full
// ("max") metadata. The default "min" metadata only has each country's general
// number pattern, which for Belgium accepts any 8-digit number, so a mobile one
// digit short passes and Twilio then refuses to text it (SM-470).
export var isValidPhone = function (phone) {
    return !!phone && isValidPhoneNumber(phone);
};
// Sign-in and password reset look up a phone that is already stored, so they keep
// the lenient "min" check: tightening it would lock out a user whose stored
// number the full metadata rejects.
export var isValidPhoneForLookup = function (phone) {
    return !!phone && isValidNumber(phone);
};
var getDigits = function (phone) { return phone.replace(/\D/g, ""); };
// Edit forms prefill the stored phone. Only a phone the user changed gets the
// full check; an unchanged stored phone keeps the lenient one, so a record whose
// stored number the full metadata rejects can still be saved, as long as the
// default metadata accepts it.
export var isValidPhoneInput = function (_a) {
    var phone = _a.phone, storedPhone = _a.storedPhone;
    var isUnchangedStoredPhone = !!phone &&
        typeof storedPhone === "string" &&
        getDigits(phone) === getDigits(storedPhone);
    return isUnchangedStoredPhone
        ? isValidPhoneForLookup(phone)
        : isValidPhone(phone);
};
// The password-reset screens take one field that holds a phone or an email.
export var getPhoneOrEmail = function (phoneOrEmail) {
    if (isValidPhoneForLookup(phoneOrEmail)) {
        return { phone: phoneOrEmail };
    }
    if (isValidEmail(phoneOrEmail)) {
        return { email: phoneOrEmail };
    }
    return {};
};
